const state = {
  selectedGuardian: {},
};

const mutations = {
  setSelectedGuardian(state, guardian) {
    state.selectedGuardian = guardian || {};
  },
  clearSelectedGuardian(state) {
    state.selectedGuardian = {};
  },
};

const actions = {
  setSelectedGuardian({ commit }, guardian) {
    commit('setSelectedGuardian', guardian);
  },
  clearSelectedGuardian({ commit }) {
    commit('clearSelectedGuardian');
  },
};

const getters = {
  selectedGuardian: (state) => state.selectedGuardian,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
